module.exports = "<div class=\"row\">\r\n    <div class=\"col-xs-12 col-md-8\">\r\n\r\n    </div>\r\n    <div class=\"col-xs-12 col-md-4\">\r\n\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets/layout.two-columns-2-1.html
// module id = 618
// module chunks = 0